import { render, staticRenderFns } from "./NewsScroll.vue?vue&type=template&id=9ce09870&"
import script from "./NewsScroll.vue?vue&type=script&lang=ts&"
export * from "./NewsScroll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports